import { activityComplementaryInfoSchema } from './activityComplementaryInfo'

export const transportComplementaryInfoSchema = {
  ...activityComplementaryInfoSchema
}
